(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
    const checkoutButton = document.getElementById('checkout');
    const paypalButton = document.querySelector(".cart-dynamic-checkout-buttons");
    const agreeTermsCheckbox = document.getElementById('checkbox-agree-terms');

    function toggleButtons() {
        const isChecked = agreeTermsCheckbox.checked;
        checkoutButton.disabled = !isChecked;
        if (paypalButton) {
            paypalButton.style.pointerEvents = isChecked ? "auto" : "none";
            paypalButton.style.opacity = isChecked ? "1" : "0.5";
        }
    }

    if (agreeTermsCheckbox) {
        agreeTermsCheckbox.checked = false; // Standardmäßig NICHT angehakt
        agreeTermsCheckbox.addEventListener("change", toggleButtons);
    }

    toggleButtons(); // Initialzustand setzen
});

  } catch(e) { console.error(e); }
})();
})();
